import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import DecisionForm from '../components/decision/DecisionForm';
import Alert from '../components/common/Alert';
import decisionService from '../services/decisionService';
import { ROUTES } from '../utils/constants';

const messageFrom = (err, fallback) => {
  const errors = err.response?.data?.errors;
  if (errors) return Object.values(errors).flat().join(' ');
  return err.response?.data?.message || err.message || fallback;
};

const DecisionPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [notice, setNotice] = useState(null); // { type, message }

  const handleDecisionSubmit = async (data) => {
    setSubmitting(true);
    setNotice(null);
    try {
      await decisionService.recordDecision(id, data);
      setNotice({ type: 'success', message: 'Decision recorded. The applicant will be notified.' });
      setTimeout(() => navigate(ROUTES.APPLICATIONS), 1500);
    } catch (err) {
      // e.g. "Cannot make a decision without a current report version" — the report step (see
      // ReportPage) needs to run for this application before a decision can be recorded.
      setNotice({ type: 'error', message: messageFrom(err, 'The decision could not be recorded.') });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="decision-page" style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <p><Link to={`${ROUTES.APPLICATIONS}/${id}`}>&larr; Back to application</Link></p>
      <h1>Record Decision</h1>
      {notice && <Alert type={notice.type} message={notice.message} dismissible onClose={() => setNotice(null)} />}
      <DecisionForm onSubmit={handleDecisionSubmit} isSubmitting={submitting} />
    </div>
  );
};
export default DecisionPage;
